import QuotasCard from "@/components/Cards/Investor/QuotasCard";
import { QuotasCardProps } from "@/components/Cards/Investor/QuotasCard/types";
import Typography from "@/components/Typography";

const QuotasSection = ({ shares }: { shares: QuotasCardProps[] }) => {
  return (
    <section className="flex h-fit flex-col gap-5 pt-8">
      <div className="flex h-fit items-center justify-between">
        <Typography variant="h4" color="black">
          Minhas cotas
        </Typography>
      </div>
      {shares.map((props, index) => {
        return <QuotasCard key={index} {...props} />;
      })}
    </section>
  );
};

export default QuotasSection;
